exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-nav-mobile-v2[data-v-28845d65] {\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-box-direction: normal;\n  -moz-box-orient: vertical;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.site-nav-mobile-v2 .site-nav-mobile-header[data-v-28845d65] {\n  border-bottom: 1px solid #f7f7f8;\n}\n.site-nav-mobile-v2 .site-nav-mobile-content[data-v-28845d65] {\n  flex: 1;\n  position: relative;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n", ""]);

// exports
